/* eslint-disable */
import getTypeof from '@/common/contact-selector/utils/getTypeof';
// todo这里边的引用有问题
import checkNativeVersion from '@/common/contact-selector/utils/checkNativeVersion';
import getDatasource from './utils/getDatasource';
import getDatasourceByGroupId from './utils/getDatasourceByGroupId';
import getPath from './utils/getPath';
import getDetailFunc from './utils/getDetail';
import getSearchResult from './utils/getSearchResult';
import { TAB_DEFAULT_CONFIG, TAB_SOURCE_TYPE } from './config';
import performanceReport from '@tencent/qd-lib/es/performanceReport';


function convertDisplayUnit(hiddenUnit) {
    const displayUnit = {};
    const keys = Object.keys(hiddenUnit);
    keys.forEach(key => {
        const displayItem = {};
        hiddenUnit[key].forEach(item => {
            displayItem[item] = {
                display: false
            };
        });
        displayUnit[key] = displayItem;
    });
    return displayUnit;
}

export default {
    name: 'QDConcatSelector',

    props: {
        modeConfig: {
            type: Object,
            default() {
                return {
                    hiddenUnit: {
                        // people: [4]
                    }
                };
            }
        }
    },

    data() {
        return {
            allowSubmitNull: 1,
            cancelButton: {
                name: '取消'
            },
            confirmButton: {
                name: '保存'
            },
            kind: 'default',
            config: {},
            exclude: {},
            ready: false,
            maxLength: 0,
            value: {},
            tabs: [],
            hiddenUnit: {},
            displayUnit: {},
            selectorConfig: TAB_DEFAULT_CONFIG,
            sourceTypeConfig: TAB_SOURCE_TYPE,
            title: '选择联系人',
            resultType: 'simple', // simple | detail
            selectedDisable: false,
            disabled: undefined, // 增加外部传入可禁用功能
            version: null,
            getDatasource,
            getDatasourceByGroupId,
            // getDetail,
            getSearchResult,
            preDatasourceMap: {},
            debug: false,
            // 全选模式设置 checkbox | text,
            selectAllMode: 'checkbox',
            // 以下属性只有pc使用
            resultConfig: {},
            warningTips: null,
            maxLengthWeakWarning: false,
            uinTails: true,
            showErrorMessageTips: true,
            // 是否可以多选
            multiple: true,
            showActionBar: true,
            selectChangeSysToPc: false,
            getPath
        };
    },

    computed: {
        getDetail() {
            return getDetailFunc(this.config);
        }
    },

    created() {
        const self = this;

        performanceReport.inject({
            monitor: window.$qidianMonitor, // qidian-moinitor 初始化之后的实例对象
            jsSdkType: 'jssdk' // jssdk
        });

        if (this.modeConfig.paramReady) {
            self.renderSelector(this.modeConfig);
        } else {
            qdp.getContactSelectorParams({
                success: res => {
                    const data = Object.assign(res.data || {}, this.modeConfig);
                    self.renderSelector(data);
                },
                fail: res => {
                    this.toast(res.errMsg || '获取配置失败');
                }
            });
        }
    },

    methods: {
        onConfirm(result) {
            const selected = { ...result };
            const codeMap = {
                troopMember: 0,
                colleague: 3,
                troop: -1,
                QQFriend: 2,
                discussMember: 1,
                discuss: -1,
                recent: -1
            };
            // 兼容pc重构前错误的参数定义
            if (selected.people && selected.people.length > 0) {
                selected.people = selected.people.map(originItem => {
                    if(typeof originItem === 'object') {
                        const item = originItem;
                        item.selectedFromTab = item.sourceType;
                        item.tabType = codeMap[item.sourceType] || null;
                        if (
                            item.extend &&
                            typeof item.extend.groupType === 'number' &&
                            item.sourceType === 'groupChatMember'
                        ) {
                            item.groupType = item.extend.groupType;
                        }
                        return item;
                    } else {
                        return originItem
                    }

                });
            }

            /**
             * 下面为针对第一期版本的兼容
             * 最初的selected的输出是按照tab分类输出的
             * 后面优化为按照元素类别（人、群组）区分，所以要对老版本的数据结构做一次兼容
             */
            if (this.contactSelectorVersion === '0.1.0') {
                selected.QQFriend = selected.people;
                delete selected.people;
            }
            /**
             * End
             */
            console.log(JSON.stringify(result));

            console.log(JSON.stringify(selected));
            if (window.CONTACT_SELECTOR_EXPORT_TYPE === 'component') {
                this.$emit('selector-confirm', {
                    selected
                });
                // 增加了个同步数据的接口 sysContactSelector， 目的是针对pc端不需要确认按钮的时候，选中后立即向pc端同步数据
            } else if (this.selectChangeSysToPc) {
                qdp.sysContactSelector({
                    selected,
                    fail: res => {
                        this.toast(res.errMsg || '提交数据失败');
                    }
                });
            } else {
                qdp.pushContactSelectorResult({
                    selected,
                    fail: res => {
                        this.toast(res.errMsg || '提交数据失败');
                    }
                });
            }
        },
        renderSelector(res) {
            if (window.$qidianMonitor) {
                window.$qidianMonitor.log(`选择器getContactSelectorParams初始化数据: ${JSON.stringify(res || {})}`);
            }
            console.log('getContactSelectorParams', res);

            const keys = Object.keys(res);
            keys.forEach(key => {
                if (typeof res[key] === 'boolean') {
                    this[key] = res[key];
                } else {
                    this[key] = typeof res[key] === 'undefined' ? this[key] : res[key];
                }
            });
            this.config = this.config || {};

            // 对群成员中的私有群进行过滤，这里早期的设计有问题，收敛到现有的过滤设计中
            const troopConfig = this.config.troopMember || {};
            troopConfig.filter = troopConfig.filter || [];
            // 如果是整形转为字符串
            troopConfig.filter = typeof troopConfig.filter === 'number' ? `${troopConfig.filter}` : troopConfig.filter;
            // 对群成员的过滤配置，统一格式化为数组格式
            if (res.troopMemberPrivacyHide === true && troopConfig.filter.indexOf('troopMemberPrivacyHide') === -1) {
                try {
                    if (getTypeof(troopConfig.filter) === 'array') {
                        troopConfig.filter.push('troopMemberPrivacyHide');
                    } else {
                        troopConfig.filter = [troopConfig.filter, 'troopMemberPrivacyHide'];
                    }
                } catch (err) {
                    // code
                }
            }
            this.config.troopMember = troopConfig;

            // 对最近联系人的sourceType做单独的设置，适应最近联系人不同类别展示
            if (this.config.recent) {
                this.selectorConfig.recent.sourceType = this.config.recent.filter || ['people', 'troop', 'discuss'];
            }
            // 通过外部配置来替换元素的原始定义，当前只有同事和好友有这个需要，所以没有写迭代赋值
            try {
                // 这里简单处理了继承关系，后面随着复杂度增加应该使用更通用的方法书写
                this.selectorConfig.colleague.config = Object.assign(
                    this.selectorConfig.colleague.config,
                    this.config.colleague.selectorConfig.config
                );
            } catch (err) {
                // no code
            }
            try {
                // 这里简单处理了继承关系，后面随着复杂度增加应该使用更通用的方法书写
                this.selectorConfig.QQFriend.config = Object.assign(
                    this.selectorConfig.QQFriend.config,
                    this.config.QQFriend.selectorConfig.config
                );
            } catch (err) {
                // no code
            }
            // 针对3.7版本以及运营包3.6.0.16856版本追加功能的向下兼容
            if (
                checkNativeVersion({
                    version: '3.7.0',
                    operator: 'gt'
                }) ||
                checkNativeVersion({
                    version: '3.7.0',
                    operator: 'eq'
                }) ||
                checkNativeVersion({
                    version: '3.6.16856',
                    operator: 'eq'
                })
            ) {
                // 3.7版本以后选择器内容不再支持checkbox模式，因为大数据量的时候始终还是有些问题
                this.selectAllMode = 'text';
            }

            if (
                checkNativeVersion({
                    version: '3.7.0',
                    operator: 'lt'
                })
            ) {
                // 如果是3.7以下版本，组织架构不支持全选，强制使用不可全选模式
                this.selectorConfig.colleague.config = Object.assign(this.selectorConfig.colleague.config, {
                    shouldSelectGroup: false,
                    dataRange: 'group'
                });
            }

            this.value = this.formatSelectedToString(res.selected || {});
            if (res.hiddenUnit) {
                this.displayUnit = convertDisplayUnit(res.hiddenUnit);
            }
            console.log("selected1111111====>", JSON.stringify(res.selected), this.value, this.contactSelectorVersion)
            /**
             * 下面为针对第一期版本的兼容
             * 最初的selected的输出是按照tab分类输出的
             * 后面优化为按照元素类别（人、群组）区分，所以要对老版本的数据结构做一次兼容
             */
            if (this.contactSelectorVersion === '0.1.0') {
                this.value.people = this.value.QQFriend;
                delete this.value.QQFriend;
            }

            /**
             * 对pc老版本（20200605之前）传参进行兼容
             */

            // 如果没有结果配置，尝试寻找以前版本的结果配置
            if (!res.resultConfig) {
                this.resultConfig = {
                    hiddenSubName: (res.resultList && res.hiddenSubName) || false,
                    resultTips: res.resultTips || ''
                };
            }

            /**
             * End
             */
            document.title = this.title;
            this.ready = true;
        },

        formatSelectedToString(originSelected) {
            const selected = originSelected;
            const keys = Object.keys(selected);
            keys.forEach(key => {
                const itemList = selected[key];
                const newList = [];
                // 传入的格式必定为数组，如果不是数组，则自动重制为空数组
                if (Array.isArray(itemList) && itemList.length !== undefined) {
                    itemList.forEach(item => {
                        newList.push(`${item}`);
                    });
                } else {
                    console.error(
                        'Error in selected params',
                        JSON.stringify(originSelected),
                        `${key}:${JSON.stringify(selected[key])}`
                    );
                    selected[key] = [];
                }
                selected[key] = newList;
            });
            return selected;
        }
    }
};
